import React, { useEffect, useState } from "react";
import Sidebar from "../layouts/sidebar";
import WindowHead from "../layouts/windowHead";
import { HiOutlineArrowRight } from "react-icons/hi";
import { useDashboardMutation } from "../../services/post";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loaders from "../../assets/loaders/loaders";
import { Link } from "react-router-dom";

function Dashboard() {

  const [showNav, setShowNav] = useState(false);

  const [dash] = useDashboardMutation();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    getDashboard();
    //eslint-disable-next-line
  }, []);


  const getDashboard = () => {
    dash()
      .then((success) => {
        setIsLoading(true);
        if (success?.data?.statusCode === 200) {
          setIsLoading(false);
          setData(success?.data?.data?.obj);
        } else if (success?.error?.data?.statusCode > 300) {
          setIsLoading(false);
          toast.error(success?.error?.data?.message);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        toast.error(error.message);
      });
  }



  return (
    <>
      {isLoading && <Loaders />}
      <ToastContainer />
      <div className="bg-inner">
        <Sidebar show={showNav} onClose={() => setShowNav(false)} />
        <div className="d-flex flex-column ms-0 ms-xxl-3 col-12 col-sm-12 col-xxl-9">
          <WindowHead sidebarOpen={() => setShowNav(!showNav)} />
          <div className="main-content">
            <div className="d-flex justify-content-between for-border">
              <h4>Detailed Dashboard</h4>
            </div>
            <div className="cards_container">
              <div className="card">
                <div>
                  <h1>{data.total_short_url}</h1>
                  <h4>SHORT URLs</h4>
                </div>
                <Link to="/manageUrl" style={{ color: "white" }}>
                  More Details <HiOutlineArrowRight />
                </Link>
              </div>
              <div className="card">
                <div>
                  <h1>{data.total_counts_of_hits}</h1>
                  <h4>CATEGORIES</h4>
                </div>
                <Link to="/manageUrl" style={{ color: "white" }}>
                  More Details <HiOutlineArrowRight />
                </Link>
              </div>
              <div className="card">
                <div>
                  <h1>{data.total_count_distinct_categories}</h1>
                  <h4>URL CLICKs</h4>
                </div>
                <Link to="/manageUrl" style={{ color: "white" }}>
                  More Details <HiOutlineArrowRight />
                </Link>
              </div>
              {/* <div className="card">
                <div>
                  <h1>{data.UPCOMING_CAMPAIGNS_IN_7DAYS}</h1>
                  <h4>TODAY'S CAMPAIGNS</h4>
                </div>
                <Link to="/todaysCampaign" style={{color:"white"}}>
                  More Details <HiOutlineArrowRight />
                </Link>
              </div>
              <div className="card">
                <div>
                  <h1>{data.TODAYS_EXECUTED_CAMPAIGNS}</h1>
                  <h4>EXECUTED CAMPAIGNS</h4>
                </div>
                <Link to="/executedCamp" style={{color:"white"}}>
                  More Details <HiOutlineArrowRight />
                </Link>
              </div>
              <div className="card">
                <div>
                  <h1>{data.TOTAL_CDR}</h1>
                  <h4>TOTAL CDRs</h4>
                </div>
                <Link to="/totalCDRs" style={{color:"white"}}>
                  More Details <HiOutlineArrowRight />
                </Link>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Dashboard;
